import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(date) {
  const parsed = dayjs(date);

  return parsed.format('YYYY-MM-DD');
}

export function getDateInMysTzFormatted(date, time) {
  return dayjs.utc(`${date}T${time}`).tz('Asia/Kuala_Lumpur').format('YYYY-MM-DD');
}

export function getDateInMysTz(date, time) {
  return dayjs.utc(`${date}T${time}`).tz('Asia/Kuala_Lumpur');
}

export function getTimeInMysTzFormatted(date, time) {
  return dayjs.utc(`${date}T${time}`).tz('Asia/Kuala_Lumpur').format('HH:mm:ss');
}

export function getDateInUtcFormatted(date, time) {
  const dateInMysTz = dayjs.tz(`${date}T${time}`, 'Asia/Kuala_Lumpur');
  return dateInMysTz.utc().format('YYYY-MM-DD');
}

export function getTimeInUtcFormatted(date, time) {
  const dateInMysTz = dayjs.tz(`${date}T${time}`, 'Asia/Kuala_Lumpur');
  return dateInMysTz.utc().format('HH:mm:ss') + 'Z';
}

export function getCurrentDateInMysTzFormatted() {
  return dayjs().tz('Asia/Kuala_Lumpur').format('YYYY-MM-DD');
}

export function getCurrentTimeInMysTzFormatted() {
  return dayjs().tz('Asia/Kuala_Lumpur').format('HH:mm:ss');
}

export function getCurrentDateInMysTz() {
  return dayjs().tz('Asia/Kuala_Lumpur');
}

export function getCurrentDateInUtc() {
  return dayjs().utc();
}

export function getDateInUtc(date, time) {
  const dateInMysTz = dayjs.tz(`${date}T${time}`, 'Asia/Kuala_Lumpur');
  return dateInMysTz.utc();
}
